import "./ImagePreview.scss";
import Modal from "react-bootstrap/Modal";
import { MdOutlineArrowForwardIos } from "react-icons/md";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { baseUrl } from "../../../utils/apiData";
import useExecuteContext from "../../../utils/hooks/executeContext";

const ImagePreview = (props) => {
  const { previewNum, setPreviewNum } = useExecuteContext();
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="preview_screen"
    >
      <Modal.Body>
        {/* Close Btn */}
        <button className="close" type="button" onClick={props.onHide}>
          <IoMdClose />
        </button>

        {/* Prev Btn */}
        <button
          type="button"
          className="prev"
          disabled={previewNum === 0}
          onClick={() => setPreviewNum((prev) => prev - 1)}
        >
          <MdOutlineArrowBackIosNew />
        </button>

        {/* Next Btn */}
        <button
          type="button"
          className="next"
          disabled={previewNum === props.datalist?.length - 1}
          onClick={() => setPreviewNum((prev) => prev + 1)}
        >
          <MdOutlineArrowForwardIos />
        </button>
        <div className="img_wrap">
          <img
            src={`${baseUrl}/${props?.datalist[previewNum]?.image}`}
            alt="Image Preview"
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ImagePreview;
